import { render, staticRenderFns } from "./snsListing.vue?vue&type=template&id=2566ce70&scoped=true&"
import script from "./snsListing.vue?vue&type=script&lang=js&"
export * from "./snsListing.vue?vue&type=script&lang=js&"
import style0 from "./snsListing.vue?vue&type=style&index=0&id=2566ce70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2566ce70",
  null
  
)

export default component.exports